import React from 'react'
import AddSchemeForm from '../../components/BudgetAllocation/Schemes/AddSchemeForm'


const AddNewScheme = () => {
  return (
    <div>
        <div className='scheme'>
            <AddSchemeForm></AddSchemeForm>
        </div>
    </div>
  )
}

export default AddNewScheme